export function getPostHeights<T extends { dayStart: number }>(
  posts: T[],
  rectangleWidth: number
): Array<T & { height: number }> {
  let height = 1,
    prevColumn: { x: number; y: number }[] = [],
    currentColumn: { x: number; y: number }[] = [],
    currentColumnStartX = -Infinity,
    prevColumnIdx = 0;
  return posts.map((post) => {
    if (post.dayStart >= currentColumnStartX + rectangleWidth) {
      // start new column
      prevColumn = currentColumn;
      currentColumn = [];
      prevColumnIdx = 1;
      height = 1;
      currentColumnStartX = post.dayStart;
    } else {
      height++;
      while (prevColumnIdx < prevColumn.length) {
        if (prevColumn[prevColumnIdx].y > height) {
          break;
        }
        if (prevColumn[prevColumnIdx].y === height && prevColumn[prevColumnIdx].x + rectangleWidth > post.dayStart) {
          // current column overlaps previous column, so we need to increase the height
          height++;
        }
        prevColumnIdx++;
      }
    }
    currentColumn.push({ x: post.dayStart, y: height });
    return { ...post, height };
  });
}
